import React from 'react';
import styles from './UserCountError.module.scss';

interface UserCountErrorProps {
	failedCount: number;
	noun: string;
	onRetry: () => void;
}

const UserCountError: React.FC<UserCountErrorProps> = ({
	failedCount,
	noun,
	onRetry
}) => (
	<div className={styles.root} role="alert">
		<span>
			Couldn't count {noun}s for {failedCount} assignment
			{failedCount === 1 ? '' : 's'}.
		</span>
		<button type="button" className={styles.retry} onClick={onRetry}>
			Retry
		</button>
	</div>
);

export default UserCountError;
